import type { RoutableQueryBuilderData } from 'shared/modules/query-builder/routable-query-builder/routable-query-builder.component';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { Store } from '@ngrx/store';
import { RuleSet } from 'angular2-query-builder/dist/components';
import { oneCourierChain } from 'app/store/project/courier-chains/courier-chains.selectors';
import { ChainNoticeCount, CouriersChainService } from 'core/http/project';
import { selectFirst } from 'core/utils/rx-common';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable()
export class RoutableQueryBuilderResolver {
  constructor(private store$: Store) {}

  resolve(route: ActivatedRouteSnapshot): Observable<RoutableQueryBuilderData> {
    const chainId = route.params.courierChainId;
    const chainedId = route.params.chainedId;

    return this.store$.pipe(
      selectFirst(oneCourierChain, { id: chainId }),
      map((chain) => {
        const chainedCourier = chain?.chainedCouriers.find(c => c.chainedId === chainedId);
        const ruleSet = chainedCourier?.ruleSet || { condition: 'and', rules: [] } as RuleSet;

        return { chainedId, ruleSet };
      }),
    );
  }
}

@Injectable()
export class CourierChainsWithCountsResolver {
  constructor(private couriersChainService: CouriersChainService) { }

  resolve(): Observable<ChainNoticeCount[]> {
    return this.couriersChainService.getNoticeChainCount();
  }
}
